import { type ReactNode } from "react";

import { ThemeContext, type Theme } from "./theme-context";

export function ThemeProvider({
  theme,
  children,
}: {
  readonly theme: Theme;
  readonly children: ReactNode;
}) {
  return (
    <ThemeContext.Provider value={theme}>{children}</ThemeContext.Provider>
  );
}
